import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import get from 'lodash.get';

import styles from './archive.css';

import ArchiveRow from '../../components/ArchiveRow/ArchiveRow';

class Archive extends Component {
	constructor(props) {
		super(props);

		this.state = {
			sort: {
				key: 'archive_year',
				order: 2
			}
		};

		this.sortByKey = this.sortByKey.bind(this);
		this.data = this.props.data;
	}

	sortedData() {
		const { key, order } = this.state.sort;

		if(key && order) {
			function compare(a, b) {
				if (get(a, key) < get(b, key)) return -1;
				if (get(a, key) > get(b, key)) return 1;
			}

			return [...this.props.data.acf.archive].sort((a, b) => {
				return compare(a, b) * (order === 1 ? 1 : -1);
			});
		}
	}

	sortByKey(key) {
		return () => {
			const sort = (this.state.sort.key === key)
			? { key, order: (this.state.sort.order == 1 ? 2 : 1) }
			: { key, order: 1 };
			this.setState({ sort });
		}
	}

	render() {
		const { archive } = this.data.acf;
		const titles = [
			{title: 'Year', sortBy: 'archive_year'},
			{title: 'Title', sortBy: 'archive_work'},
			{title: 'Role', sortBy: null},
			{title: 'Studio', sortBy: null},
			{title: 'Link', sortBy: null}
		];
		const sorted = this.sortedData();

		return (
			<table className={styles.table}>
				<thead className={styles.thead}>
					<tr className={styles.tr}>
					{
						titles.map((data, index) =>
							<th
								key={index}
								className={styles.th}>
								<h3
								onClick={index < 2 ? this.sortByKey(data.sortBy) : false}
								className={styles.title}>{data.title}
								{index < 2 ? (this.state.sort.order == 2 && this.state.sort.key == data.sortBy ? '↓'  : '↑' ) : null}
								</h3>
							</th>
						)
					}
					</tr>
				</thead>
				<tbody>
					{
						sorted.map((item, index) =>
							<ArchiveRow key={index} titles={titles} item={item} />
						)
					}
				</tbody>
			</table>
		);
	}
}

export default Archive;



// WEBPACK FOOTER //
// ./src/components/Archive/Archive.js